var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0057FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18C17.25 18 15.4825 17.3044 14.0526 16.7472H8.03893C7.32693 16.7472 6.75 16.135 6.75 15.3801V7.3667C6.75 6.61224 7.32693 6 8.03893 6H15.9603C16.6723 6 17.2496 6.61224 17.2496 7.3667L17.25 18ZM15.2135 13.4671C15.3572 13.3365 15.5746 13.3539 15.698 13.5066C15.8219 13.6596 15.8047 13.8894 15.6606 14.0208C15.6079 14.0688 14.3343 15.2019 11.9993 15.2019C9.66534 15.2019 8.39212 14.0688 8.33862 14.0208C8.19457 13.8894 8.17736 13.6596 8.3012 13.5066C8.42467 13.3543 8.64093 13.3361 8.78497 13.4663C8.81032 13.4883 9.94665 14.473 11.9993 14.473C14.0829 14.473 15.2023 13.4771 15.2135 13.4671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.e0e8f5e3faeaca510a62f9fe4322f30e.svg";
export { ForwardRef as ReactComponent };